<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="header">
      <div class="title-color">
        @if (!group) {
          <h1 class="title">Crear grupo</h1>
        }
      </div>

      <div class="title-color">
        @if (group) {
          <h1 class="title">Editar grupo</h1>
        }
      </div>
    </div>
    <div class="form-body">
      <form [formGroup]="groupForm" (ngSubmit)="onCreateGroup()">
        <div class="line">
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Nombre del grupo</mat-label>
              <input type="text" matInput required formControlName="name" />
            </mat-form-field>
           </div>
            <div class="checkbox-grid">
            <mat-checkbox matInput formControlName="create" title="create"> Create </mat-checkbox>
            <mat-checkbox matInput formControlName="update" title="update"> Update </mat-checkbox>
            <mat-checkbox matInput formControlName="delete" title="delete"> Delete </mat-checkbox>
            <mat-checkbox matInput formControlName="read" title="read"> Read </mat-checkbox>
          </div>

          <div class="duallist-ui">
            <dual-list
              display="name"
              key="id"
              [source]="permisions"
              [(destination)]="selected"
              height="250px"
              [format]="format"
              [filter]="true"
            >
            </dual-list>
          </div>
        </div>

        <br />
        <button class="primary-button" type="submit">
          <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
        </button>
        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
